import { Injectable } from '@angular/core';
import { ApiDashboardService } from '../api/api-dashboard.service';

@Injectable({
  providedIn: 'root'
})
export class HomeDashboardService {

  constructor(public apiService: ApiDashboardService) { }

  walletAmount() {
    return this.apiService.getWalletAmount()
  }

  residuary() {
    return this.apiService.getResiduary()
  }

  clientsOverdue() {
    return this.apiService.getClientsOverdue()
  }

  monthlyTarget() {
    return this.apiService.getMonthlyTarget()
  }

  assets() {
    return this.apiService.getAssets()
  }

  newLeases() {
    return this.apiService.getNewLeases()
  }

  pendingBalances() {
    return this.apiService.getPendingBalances()
  }

  monthlyLeaseBalances() {
    return this.apiService.getMonthlyLeaseBalances()
  }
}
